



















































import { Event } from '@ssp/inscreva-sse-models';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';

import CustomWarningComponent from '../components/CustomWarningComponent.vue';
import Loading from '../components/Loading.vue';
import SignUpComponent from '../components/SignUpComponent.vue';
import { EventUI } from '../models/event-ui';
import { eventUIStore } from '../store/event-ui';

@Component({
  components: {
    Loading,
    CustomWarningComponent,
    SignUpComponent,
  },
})
export default class SignUpPage extends Vue {
  isLoading = false;

  eventUI: EventUI = null;

  async mounted() {
    this.isLoading = true;
    const eventAlias = this.$route.params.alias;

    this.eventUI = await eventUIStore.fromAlias(eventAlias);
    this.isLoading = false;
  }

  get event() {
    return this.eventUI.event as Event;
  }

  get hasFinished() {
    return moment().isAfter(this.event.info.dates[this.event.info.dates.length - 1].end);
  }
}
